import { IconWrapper } from '../runtime';
export default IconWrapper('ofd_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
      "fill": "#1289DE"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 18.375H24V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V18.375Z",
      "fill": "#0475C5"
    }
  }), h("path", {
    "attrs": {
      "d": "M21 1.14742e-07C22.6569 1.87166e-07 24 1.34315 24 3L24 21.0968C24 22.7002 22.7002 24 21.0968 24C19.5936 24 18.375 22.7814 18.375 21.2782L18.375 0L21 1.14742e-07Z",
      "fill": "#239FF7"
    }
  }), h("path", {
    "attrs": {
      "d": "M18.375 21.2782C18.375 22.7814 19.5936 24 21.0968 24C22.7002 24 24 22.7002 24 21.0968C24 19.5936 22.7814 18.375 21.2782 18.375H18.375V21.2782Z",
      "fill": "#1289DE"
    }
  }), h("path", {
    "attrs": {
      "d": "M5.625 6.5625H7.5V15H5.625V6.5625Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M3.375 7.78125H9.5625V9.65625H3.375V7.78125Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M8.71875 3.46875H9.5625V5.34375H8.71875V3.46875Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M11.0625 3.46875H11.9062V5.34375H11.0625V3.46875Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M11.0625 7.78125H11.9062V9.65625H11.0625V7.78125Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8.8125 9.65625H8.71875C7.01012 9.65625 5.625 8.27113 5.625 6.5625C5.625 4.85387 7.01012 3.46875 8.71875 3.46875H8.8125V5.34375H8.71875C8.04565 5.34375 7.5 5.8894 7.5 6.5625C7.5 7.2356 8.04565 7.78125 8.71875 7.78125H8.8125V9.65625Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M11.8125 9.65625H11.9062C13.6149 9.65625 15 8.27113 15 6.5625C15 4.85387 13.6149 3.46875 11.9062 3.46875H11.8125V5.34375H11.9062C12.5793 5.34375 13.125 5.8894 13.125 6.5625C13.125 7.2356 12.5793 7.78125 11.9062 7.78125H11.8125V9.65625Z",
      "fill": "white"
    }
  })]);
});